<div class="flex flex-col flex-gap-8-4">
  <div class="flex flex-gap-8-4 flex-center">
    <label class="label-inline">From:</label>
    <shared-date-time-picker [(ngModel)]="from" (ngModelChange)="onFromChange($event)" [ngModelOptions]="{ standalone: true }" [minDate]="minDate" [maxDate]="maxDate" [displayTime]="displayTime" />
  </div>
  <div class="flex flex-gap-8-4 flex-center">
    <label class="label-inline">To:</label>
    <shared-date-time-picker [(ngModel)]="to" (ngModelChange)="onToChange($event)" [ngModelOptions]="{ standalone: true }" [minDate]="minDate" [maxDate]="maxDate" [displayTime]="displayTime" />
  </div>
</div>
